var installedModules = {};
var moduleToHandlerMapping = {
	67077: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(11855); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	59442: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(75541); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	41965: {
		getter: function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(8884)]).then(function() { return function() { return __webpack_require__(9388); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	12974: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(63159); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	83803: {
		getter: function() { return Promise.all([__webpack_require__.e(9014), __webpack_require__.e(6983), __webpack_require__.e(6757), __webpack_require__.e(1965), __webpack_require__.e(6112)]).then(function() { return function() { return __webpack_require__(76757); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	38430: {
		getter: function() { return __webpack_require__.e(1983).then(function() { return function() { return __webpack_require__(51983); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	92662: {
		getter: function() { return __webpack_require__.e(4136).then(function() { return function() { return __webpack_require__(21755); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	49501: {
		getter: function() { return __webpack_require__.e(4136).then(function() { return function() { return __webpack_require__(21755); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	35603: {
		getter: function() { return __webpack_require__.e(2729).then(function() { return function() { return __webpack_require__(85110); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	32306: {
		getter: function() { return __webpack_require__.e(2729).then(function() { return function() { return __webpack_require__(85110); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	78285: {
		getter: function() { return Promise.all([__webpack_require__.e(9014), __webpack_require__.e(4840), __webpack_require__.e(4381)]).then(function() { return function() { return __webpack_require__(34840); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	53300: {
		getter: function() { return Promise.all([__webpack_require__.e(6983), __webpack_require__.e(1965), __webpack_require__.e(1238)]).then(function() { return function() { return __webpack_require__(51983); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	94868: {
		getter: function() { return Promise.all([__webpack_require__.e(8027), __webpack_require__.e(1965), __webpack_require__.e(5070)]).then(function() { return function() { return __webpack_require__(38027); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	94260: {
		getter: function() { return __webpack_require__.e(4136).then(function() { return function() { return __webpack_require__(21755); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	77211: {
		getter: function() { return __webpack_require__.e(3313).then(function() { return function() { return __webpack_require__(15694); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	41554: {
		getter: function() { return __webpack_require__.e(4180).then(function() { return function() { return __webpack_require__(11799); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	52224: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(18959); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/server",
	},
	98015: {
		getter: function() { return __webpack_require__.e(1983).then(function() { return function() { return __webpack_require__(51983); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	72267: {
		getter: function() { return __webpack_require__.e(4840).then(function() { return function() { return __webpack_require__(34840); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	29253: {
		getter: function() { return __webpack_require__.e(8027).then(function() { return function() { return __webpack_require__(38027); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	}
};
var initialConsumes = [67077,59442,41965,12974,83803,38430,92662,49501,35603,52224,98015,72267,29253];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"636": [
		12974,
		83803,
		38430,
		92662,
		49501,
		35603
	],
	"1965": [
		41965
	],
	"2267": [
		72267
	],
	"5120": [
		32306,
		83803,
		78285,
		53300,
		94868,
		94260,
		77211,
		41554,
		12974
	],
	"8292": [
		52224,
		98015
	],
	"8792": [
		67077,
		59442,
		41965
	],
	"8884": [
		67077
	],
	"8920": [
		29253
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}